module.exports = __webpack_public_path__ + "img/video203.4727129a.jpeg";